import React, { useState, useEffect } from 'react';
import {
    Box,
    Alert,
    CircularProgress,
    Paper,
    SelectChangeEvent,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import { CustomerData, useCustomer } from '../../context/CustomerContext';
import { pointApi } from '../../api/data/pointApi';
import { useAuth } from '../../hooks/useAuth';
import { useFetch } from '../../hooks/useFetch';
import { Customer, getCustomersVL, ValueLabel } from '../../api/data/customerTools';

export const SelectCustomer: React.FC = () => {
    const [error, setError] = useState<string | null>(null);
    const { data: customers, loading } = useFetch<ValueLabel[]>(getCustomersVL, []);
    const customer = useCustomer();
    const [selectedCustomer, setSelectedCustomer] = useState<number>(customer.customerData?.customer || 10); 
    const auth = useAuth();

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedCustomer(parseInt(event.target.value));
        console.log("Выбран ID клиента:", event.target.value);
    };

    const handleSave = async () => {
        console.log("Сохраняем выбранный ID клиента:", selectedCustomer);
        const res = await auth.updateCustomer(selectedCustomer);
        if (!res) {
            console.warn("updateCustomer failed, cannot update customer.");
            return;
        }

        // Обновляем состояние контекста клиента
        const temp = customer.customerData;
        if (!temp) {
            console.warn("customerData is null, cannot update customer.");
            return;
        }
        temp.customer = selectedCustomer;
        const points = (await (pointApi.getPoints() || [])).map(point => ({
            value: point.point_id,
            label: point.name,
        }));
        temp.points = [];
        points.forEach((point) => {
            temp.points?.push(point);
            console.log("Добавляем point:", point);
        });
        customer.customerData = temp;
        console.log("Обновленный контекст клиента:", customer.customerData);

        alert("Выбранный клиент сохранен");
    };

    return (
        <Paper sx={{ p: 3, m: 2, maxWidth: 500, margin: 'auto' }}>
            <Typography variant="h5" gutterBottom>
                Вибір клієнта
            </Typography>
            <Box sx={{ mt: 2 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Alert severity="error">{error}</Alert>
                ) : (
                    <>
                    <FormControl fullWidth>
                        <InputLabel id="customer-select-label">Клиент</InputLabel>
                        <Select
                            labelId="customer-select-label"
                            id="customer-select"
                            value={String(selectedCustomer)}
                            label="Клієнт"
                            onChange={handleChange}
                        >
                            {customers.map((customer) => (
                                <MenuItem key={customer.value} value={customer.value}>
                                    {customer.value} - {customer.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            fullWidth
                            disabled={loading} // Кнопка неактивна пока идет загрузка
                            sx={{ mt: 20 }} // отступ сверху
                        >
                            Зберегти вибір
                    </Button>
                    </>
                )}
            </Box>
        </Paper>
    );
};
